import React, { useEffect } from 'react'
import { PageHeader } from '../../../../common/index'
import { useNavigationContext } from '../../../../context/NavigationContext'
import { useDashboardAssociationContext } from '../../../../context/DashboardAssociationContext'
import { Booklet } from '../../../../types/generated.types'
import BookletCard from './BookletCard'


const DashboardBooklets = () => {
  const { associationBooklets } = useDashboardAssociationContext()
  const { setNavigationActivated } = useNavigationContext()

  useEffect(() => {
    setNavigationActivated(true)
  }, [setNavigationActivated])

  return (
    <div id="dashboard" className="booklets">
      <PageHeader>
        <h1>Häften</h1>
        <p>Här ser du era häften</p>
      </PageHeader>
      <div className="container">
        <div className="booklets-list">
          {associationBooklets.map((booklet: Booklet) => (
            <BookletCard
              key={booklet._id}
              booklet={booklet}
            />
          ))}
          {associationBooklets.length === 0 && (
            <div className="no-booklets">
              <p>Inga häften tillgängliga för denna förening.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default DashboardBooklets
